import { render, staticRenderFns } from "./BrowseDaichoView.vue?vue&type=template&id=f09ff9f0&scoped=true&"
import script from "./BrowseDaichoView.vue?vue&type=script&lang=js&"
export * from "./BrowseDaichoView.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDaichoView.vue?vue&type=style&index=0&id=f09ff9f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ff9f0",
  null
  
)

export default component.exports